import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ophir_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getContent = () => api.get('/content').then((r) => r.data);
export const submitSupplier = (data) => api.post('/submissions/supplier', data).then((r) => r.data);
export const submitBuyer = (data) => api.post('/submissions/buyer', data).then((r) => r.data);
export const submitContact = (data) => api.post('/submissions/contact', data).then((r) => r.data);
export const submitRfq = (data) => api.post('/submissions/rfq', data).then((r) => r.data);
export const uploadFile = (file, onProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  return api
    .post('/uploads', fd, {
      // NOTE: do NOT set Content-Type manually. The browser must set
      // "multipart/form-data; boundary=..." automatically, otherwise the
      // backend rejects the request with "Missing boundary in multipart".
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    })
    .then((r) => r.data);
};

// Admin
export const adminLogin = (email, password) =>
  api.post('/admin/login', { email, password }).then((r) => r.data);
export const adminMe = () => api.get('/admin/me').then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.post('/admin/change-password', { current_password, new_password }).then((r) => r.data);
export const listSubmissions = (params) =>
  api.get('/admin/submissions', { params }).then((r) => r.data);
export const getSubmission = (id) => api.get(`/admin/submissions/${id}`).then((r) => r.data);
export const updateSubmission = (id, body) =>
  api.patch(`/admin/submissions/${id}`, body).then((r) => r.data);
export const getStats = () => api.get('/admin/submissions/stats').then((r) => r.data);
export const updateContent = (payload) => api.put('/admin/content', payload).then((r) => r.data);
export const exportUrl = (type) =>
  `${API}/admin/submissions/export${type ? `?type=${type}` : ''}`;
export const downloadDoc = (fileId) =>
  api.get(`/admin/uploads/${fileId}`, { responseType: 'blob' }).then((r) => r.data);
